export default "__VITE_ASSET__DOazS4O___"